import React from 'react';

interface CustomSubTitleProps {
  subtitle?: string | null;
  subTitleStyle?: {
    fontSize?: string;
    color?: string;
    alignment?: string;
    alignmentClass?: string; // For pre-calculated alignment classes
    [key: string]: any; // Allow other styling properties
  } | null;
  className?: string; // Additional classes to apply
}

const CustomSubTitle = ({
  subtitle,
  subTitleStyle,
  className = '',
}: CustomSubTitleProps) => {
  const getSubtitleFontSize = () => {
    if (!subTitleStyle?.fontSize) return 'text-sm sm:text-base lg:text-lg';

    switch (subTitleStyle.fontSize) {
      case 'small':
        return 'text-xs sm:text-sm lg:text-base';
      case 'medium':
        return 'text-sm sm:text-base lg:text-lg';
      case 'large':
        return 'text-base sm:text-lg lg:text-xl';
      default:
        return 'text-sm sm:text-base lg:text-lg';
    }
  };

  const inlineStyle: React.CSSProperties = {
    color: subTitleStyle?.color || '#fff',
  };

  if (subTitleStyle) {
    Object.keys(subTitleStyle).forEach((key) => {
      // Skip properties we've already handled or that should be in className
      if (!['fontSize', 'color', 'alignment', 'alignmentClass'].includes(key)) {
        // Use the key as-is (camelCase) for React inline styles
        inlineStyle[key] = subTitleStyle[key];
      }
    });
  }

  const alignmentClass = subTitleStyle?.alignmentClass || 'text-center';

  return (
    <p
      className={`mt-1.5 lg:mt-2 ${getSubtitleFontSize()} w-full ${alignmentClass} ${className}`}
      style={inlineStyle}
    >
      {subtitle}
    </p>
  );
};

export default CustomSubTitle;
